export enum QrCodeVariants {
  GREY_BACKGROUND = 'greyBackground',
  WHITE_BACKGROUND = 'whiteBackground',
}

export default interface QrCodeProps {
  href: string,
  variant: QrCodeVariants,
}
